import React from 'react';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import './steps.scss';

// const data =[
//   {
//     status:'finish',         // unread draft finish 四种状态
//     text:'finish',           // 显示的文本内容
//     isShowChecked:true,      // 是否显示对勾
//     iconClassName:'',        // 圆圈的类名
//     barClassName:'',         // 进度条的类名
//     iconStyles:{},           // 圆圈的样式
//     processBarStyles:{},     // 进度条的样式
//   }
// ]
const IndividualSteps = ({
  data = [],
  isShowChecked = false, // 是否全显示对勾
  step, // 当前完成的进程的位置
  isShowText = false, // 是否显示文本
  textStyles = {}, // 文本的样式
  iconPublicStyles = {}, // 圆圈的样式
  processPublicStyles = {}, // 进度条的样式
  isShowLastProgressBar = false, // 是否显示最后一个的进度条
  currentStep = 0, // 显示当前操作的步骤
  click = () => {}, // 圆圈的点击事件
  tooltipBackgroundColor,
}) => {
  const flagNum =
    Array.isArray(data) &&
    data.findIndex((item = {}) => item.status === 'unread');
  return (
    <div className="steps-box">
      {Array.isArray(data) &&
        data.map((item = {}, idx) => {
          const status = item.status;
          return (
            <div
              className={`step-box ${
                !isShowLastProgressBar && 'is-show-last-progress-bar'
              }`}
              key={item.status + idx + item.text}
            >
              {item.tooltipText ? (
                <Tooltip
                  title={item.tooltipText}
                  color={tooltipBackgroundColor}
                  placement={
                    idx === data?.length - 1 ? 'bottomRight' : 'bottomLeft'
                  }
                >
                  <div
                    className={`
                                icon 
                                common-styles 
                                ${
                                  item.isShowChecked ||
                                  (isShowChecked && step > idx)
                                    ? null
                                    : 'is-show-checked'
                                }
                                ${status}
                                ${item.iconClassName}
                                ${step > idx ? 'finish' : 'unread'}
                                ${currentStep === idx + 1 && 'current-step'}
                                
                              `}
                    style={{ ...item.iconStyles, ...iconPublicStyles }}
                    onClick={() => click(item, idx, data)}
                  />
                </Tooltip>
              ) : (
                <div
                  className={`
                            icon 
                            common-styles 
                            ${
                              item.isShowChecked ||
                              (isShowChecked && step > idx)
                                ? null
                                : 'is-show-checked'
                            }
                            ${status}
                            ${item.iconClassName}
                            ${step > idx ? 'finish' : 'unread'}
                            ${currentStep === idx + 1 && 'current-step'}
                          `}
                  style={{ ...item.iconStyles, ...iconPublicStyles }}
                  onClick={() => click(item, idx, data)}
                />
              )}

              <div
                className={`
                            process-bar
                            ${item.barClassName}
                            ${
                              idx < flagNum - 1 || flagNum === -1
                                ? 'bar-finished'
                                : null
                            }
                          `}
                style={{ ...item.processBarStyles, ...processPublicStyles }}
              />

              {isShowText && (
                <span className="explain-text" style={textStyles}>
                  {item.text}
                </span>
              )}
            </div>
          );
        })}
    </div>
  );
};
IndividualSteps.propTypes = {
  data: PropTypes.array.isRequired,
  isShowChecked: PropTypes.bool,
  step: PropTypes.number,
  isShowText: PropTypes.bool,
  textStyles: PropTypes.object,
  iconPublicStyles: PropTypes.object,
  processPublicStyles: PropTypes.object,
  isShowLastProgressBar: PropTypes.bool,
  currentStep: PropTypes.number,
  click: PropTypes.func,
};
export default IndividualSteps;
